import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { getDefaultDates } from '../utils/weekDates';

const CustomerInfo = () => {
  const defaults = getDefaultDates();
  const [menuTypes, setMenuTypes] = useState([]);
  const [selectedMenuType, setSelectedMenuType] = useState('');
  const [pendingStart, setPendingStart] = useState(defaults.start);
  const [pendingEnd, setPendingEnd] = useState(defaults.end);
  const [customers, setCustomers] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  const authHeaders = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  const fetchCustomers = async (start, end, menuType) => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams({ startDate: start, endDate: end });
      if (menuType) params.set('menuType', menuType);
      const res = await fetch(
        `https://api.reshipesbakery.com/reshipes/getThisWeeksCustomerInformation?${params}`,
        { headers: authHeaders }
      );
      if (!res.ok) throw new Error('Failed to load customer info');
      setCustomers(await res.json());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch('https://api.reshipesbakery.com/reshipes/getMenuTypes', { headers: authHeaders })
      .then(r => r.ok ? r.json() : []).then(setMenuTypes).catch(() => {});
    fetchCustomers(defaults.start, defaults.end, '');
  }, [token]);

  const handleApply = () => fetchCustomers(pendingStart, pendingEnd, selectedMenuType);

  return (
    <div className="container mt-5">
      <h1>Customer Info</h1>

      <div className="mt-3 d-flex flex-wrap gap-3 align-items-end">
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>Menu</label>
          <select
            className="form-select form-select-sm"
            value={selectedMenuType}
            onChange={e => setSelectedMenuType(e.target.value)}
            style={{ minWidth: 160 }}
          >
            <option value="">All Menus</option>
            {menuTypes.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>From</label>
          <input type="date" className="form-control form-control-sm"
            value={pendingStart} onChange={e => setPendingStart(e.target.value)} />
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>To</label>
          <input type="date" className="form-control form-control-sm"
            value={pendingEnd} onChange={e => setPendingEnd(e.target.value)} />
        </div>
        <button className="btn btn-primary btn-sm" onClick={handleApply}>Apply</button>
      </div>

      {loading && <div className="mt-4">Loading…</div>}
      {error && <div className="mt-4 text-danger">{error}</div>}

      {!loading && customers && customers.length === 0 && (
        <p className="mt-4">No customers found for this period.</p>
      )}

      {!loading && customers && customers.length > 0 && (
        <div className="mt-4">
          {customers.map((customer, index) => (
            <div key={index} className="mt-4">
              <h3>{customer.name}</h3>
              <p>Email: {customer.email}</p>
              <p>Phone: {customer.phoneNumber || '—'}</p>
              <p>Address: {customer.streetAddress}{customer.aptNumber ? `, Apt ${customer.aptNumber}` : ''}</p>
              <p>City: {customer.city}</p>
              <p>State: {customer.state}</p>
              <p>Zip Code: {customer.zipCode}</p>
              <p>Order Date: {customer.orderDate}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomerInfo;
